import { createContext } from 'react';

const institutionContext = createContext();

export default institutionContext;
